export const FETCH_BRAND_DATA = "FETCH_BRAND_DATA";
export const FETCH_BRAND_DATA_SUCCESS = "FETCH_BRAND_DATA_SUCCESS";
